import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

const NOTE_FIELD_MAX_LENGTH = 200;

type NoteFormBeanPart = {
   note: string | null;
};

type NoteFieldProps = {
   register: BindingCreator<NoteFormBeanPart>;
};

export const NoteField = (props: NoteFieldProps): ReactElement => {
   return (
      <TextInput
         testId={'note'}
         controller={props.register('note', { maxLength: NOTE_FIELD_MAX_LENGTH })}
         label={translationKeys.note}
         maxLength={NOTE_FIELD_MAX_LENGTH}
      />
   );
};
